import {getTextByValue} from "../../../Utilities/Types/listUtilities";
import {LOAN_STATUS_LIST} from "./LoanManagement/loanConstants";

export const getLoanStatusTextByValue = (value: string | number = "") => getTextByValue(LOAN_STATUS_LIST, value);
